import { useCallback } from "react";

import { AwsIntegrationIntentProjectAttachment } from "types/generated";
import useDetachIntegration from "shared/IntentProject/useDetachIntegration";
import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";

import IntentProjectDetailsCard from "./Card";

type IntentProjectAwsIntegrationDetailsProps = {
  attachment: AwsIntegrationIntentProjectAttachment;
  intentProjectId: string;
  readOnly?: boolean;
  onSuccessDetach?: () => void;
};

const IntentProjectAwsIntegrationDetails = ({
  attachment,
  intentProjectId,
  readOnly,
  onSuccessDetach,
}: IntentProjectAwsIntegrationDetailsProps) => {
  const { detachIntegration, loading: detachLoading } = useDetachIntegration();
  const { onError } = useTypedContext(FlashContext);

  const handleDetach = useCallback(async () => {
    try {
      await detachIntegration({
        intentProjectId,
        integrationId: attachment.awsIntegration.id,
      });
      onSuccessDetach?.();
    } catch (error) {
      onError(error);
    }
  }, [detachIntegration, intentProjectId, attachment.awsIntegration.id, onSuccessDetach, onError]);

  return (
    <IntentProjectDetailsCard
      attachedIntegration={attachment}
      readOnly={readOnly}
      onDetach={handleDetach}
      detachLoading={detachLoading}
    />
  );
};

export default IntentProjectAwsIntegrationDetails;
